import SeeDetailsModal from './SeeDetailsModal';

export default SeeDetailsModal;
